// extracted by mini-css-extract-plugin
export default {"home":"index_home__9KcK6","content":"index_content__hwV++","select":"index_select__VkUMp"};